import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { gql } from "@apollo/client";
import { metaResolveType, createPageInfo } from "./helper";
export const typeDef = gql`
  type TrackResult {
    result: Boolean
  }

  union RecommendMeta = EpisodeMeta | LiveMeta | TVShowMeta

  type RecommendConnection @cacheControl(scope: PRIVATE, maxAge: 0) {
    elementId: String
    data: [RecommendMeta]
    pageInfo: PageInfo
  }

  type Mutation {
    track(location: String!, referrer: String, sid: String): TrackResult
  }

  type Query {
    recommend(location: String!, elementIds: [String!]): [RecommendConnection]
  }
`;
export const resolvers = {
  Mutation: {
    track: async (_parent, _ref, _ref2) => {
      let {
        location,
        referrer,
        sid
      } = _ref;
      let {
        req,
        dataSources
      } = _ref2;
      try {
        const options = (() => {
          if (sid) {
            return {
              "_rt.sid": sid
            };
          }
          return null;
        })();
        await dataSources.rtoaster.track(location, referrer, options);
        return {
          result: true
        };
      } catch (e) {
        console.log(e);
        return {
          result: false
        };
      }
    }
  },
  Query: {
    recommend: async (_parent, _ref3, _ref4) => {
      let {
        location,
        elementIds
      } = _ref3;
      let {
        req,
        dataSources
      } = _ref4;
      try {
        const response = await dataSources.rtoaster.recommend(location, elementIds);
        if (response !== null && response !== void 0 && response.result) {
          const result = response.result.map(v => {
            // こう言う形で入ってくるので加工する
            // {
            //   attributes: {
            //     elementId: 'rt_detail_user_auto_10',
            //     sessionId: 'P38ddfa39298f7f70001174e0000001400000000412c302a'
            //   },
            //   '$value': '<div>63988</div>'
            // }
            const elementId = elementIds.find(elId => !!~v.attributes.elementId.indexOf(elId));
            const matched = v["$value"].match(/(?<id>\d+)/);
            const value = Number(matched.groups.id);
            return {
              elementId: elementId,
              rtsid: v.attributes.sessionId,
              id: value
            };
          }).reduce((acc, v) => {
            // elementIdごとにまとめる
            if (!acc[v.elementId]) {
              acc[v.elementId] = [];
            }
            acc[v.elementId].push({
              id: v.id,
              rtsid: v.rtsid
            });
            return acc;
          }, {});
          const promises = Object.keys(result).map(async elementId => {
            const ids = result[elementId].map(v => v.id);
            const {
              metas
            } = await dataSources.meta.searchFromId(ids);
            const metasWithRtsid = result[elementId].map(_ref5 => {
              let {
                id,
                rtsid
              } = _ref5;
              const meta = metas.find(meta => meta.id === id);
              if (meta) {
                return _objectSpread(_objectSpread({}, meta), {}, {
                  rtsid
                });
              } else {
                return null;
              }
            }).filter(x => !!x);
            return {
              elementId,
              data: metasWithRtsid,
              pageInfo: createPageInfo({
                offset: 0,
                limit: metasWithRtsid.length,
                count: metasWithRtsid.length
              })
            };
          });
          return await Promise.all(promises);
        }
      } catch (e) {
        console.log("rtoaster recommend error", e);
      }
    }
  },
  RecommendMeta: {
    __resolveType: metaResolveType
  }
};